export function getMediaUrl(url: string | undefined): string {
  if (!url) return '';
  try {
    if (url.startsWith('/')) {
      return url;
    }
    if (url.startsWith('http://') || url.startsWith('https://')) {
      const parsed = new URL(url);
      if (parsed.pathname.includes('/media/')) {
        return parsed.pathname;
      }
    }
  } catch {
    return url;
  }
  return url;
}
